"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRemoveDrillsByOrigins = void 0;
var general_1 = require("../../../events/general");
var sdk_model_1 = require("@gooddata/sdk-model");
var insightDrillDefinitionUtils_1 = require("./insightDrillDefinitionUtils");
var insight_1 = require("../../../commands/insight");
function validateRemoveDrillsByOrigins(drillSelector, drills, ctx, cmd) {
    if (insight_1.isAllDrillSelector(drillSelector)) {
        return drills;
    }
    return drillSelector.map(function (drillRef) {
        try {
            return insightDrillDefinitionUtils_1.validateDrillDefinitionByLocalIdentifier(drillRef, drills);
        }
        catch (ex) {
            var messageDetail = ex.message;
            throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid measure or attribute origin: " + sdk_model_1.objRefToString(drillRef) + ". Error: " + messageDetail);
        }
    });
}
exports.validateRemoveDrillsByOrigins = validateRemoveDrillsByOrigins;
//# sourceMappingURL=removeDrillsSelectorValidation.js.map